<div mat-dialog-title>
    <span>{{'action.configuration' | translate}}</span>
    <button [mat-dialog-close]="data">
        <i class="fa fa-times"></i>
    </button>
</div>

<mat-dialog-content>
    <!-- PART 2 -->
    <div class="">
        <h3>{{'subscriptions.modal.detail.configuration.import_export' | translate}}</h3>
        
        <div class="wrap-file-actions">
            <app-file-download (userWantsDownloadEvent)="onUserWantsDownloadEvent($event)" [backendResponse]="backendResponseDownloadedFile"></app-file-download>
            <app-file-upload (userWantsUploadEvent)="onUserWantsUploadEvent($event)" [backendResponse]="backendResponseUploadedFile"></app-file-upload>
        </div>
    </div>
    <div [appReadWrite]="FEATURE.USER" class="">

           <app-modal-users [calledByOtherComponent]="calledByOtherComponent" [uid]="uid"></app-modal-users>
        
    </div>
    <div [appReadWrite]="FEATURE.VEHICLE" class="">
      
            <app-modal-vehicles [calledByOtherComponent] ="calledByOtherComponent" [uid]="uid"></app-modal-vehicles>
        
    </div>
</mat-dialog-content>